import { epics as createEpics } from './create';
import list, { epics as listEpics } from './list';

export const epics = [
  ...createEpics,
  ...listEpics,
];

export default list;
